const actionType = {
  SET_MOVIES: "SET_MOVIES",
  CLEAR_MOVIES: "CLEAR_MOVIES"
}

export default actionType;
